export const ANALYTIC_EVENTS = {
  AI_POLICY: {
    HARDEN: {
      VIEWED: "ai_policy_harden_viewed",
      APPROVED: "ai_policy_harden_approved",
      EDIT_OPENED: "ai_policy_harden_edit_opened"
    }
  },
  LOGIN: "LOGIN",
  NAVIGATION: "NAVIGATION",
  PAGE_OPENED: "PAGE_OPENED",
  pageView: "page.view",
  OPEN_API_DOCUMENTATION: "open_api_documentation",
  CLICK_SHARE_BUTTON: "click_share_button",
  DASHBOARD: {
    POSTURE_SCORE_OVERTIME: { HOVER: "dashboard.posture_score_overtime.hover" },
    CLICK_INVENTORY_SNAPSHOT: {
      APPLICATIONS: "dashboard.inventory_snapshot.applications",
      CODE_REPOSITORIES: "dashboard.inventory_snapshot.code_repositories",
      IMAGES: "dashboard.inventory_snapshot.images",
      BASE_IMAGES: "dashboard.inventory_snapshot.base_images",
      PACKAGES: "dashboard.inventory_snapshot.packages"
    },
    FUNNEL: { NAVIGATION: "dashboard.funnel.navigation" },
    VULNERABLE_FUNCTION: {
      ISSUE_WITH_VULNERABLE_FUNCTION_CLICKED:
        "dashboard.vulnerable_function.issue_with_vulnerable_function.clicked",
      ISSUE_WITH_NO_VULNERABLE_FUNCTION_CLICKED:
        "dashboard.vulnerable_function.issue_with_no_vulnerable_function.clicked"
    },
    EXPLOITABLE_ISSUE: {
      NAVIGATION_TO_ISSUES_PAGE: "dashboard.exploitable_issue.navigation"
    },
    ISSUE_TYPES_BY_SEVERITY: {
      ISSUE_TYPE_CLICKED: "dashboard.issue_types_by_severity.issue_type.clicked"
    },
    TOP_ISSUES: { ISSUE_CLICKED: "dashboard.top_issues.issue.clicked" }
  },
  INTEGRATIONS: {
    CLICKED: "integrations.clicked",
    OPENED_INSTRUCTION: "integrations.instructions",
    OPENED_CONNECT: "integrations.connect",
    METHOD_SELECTED: "integrations.method_selected",
    COMMAND_CONNECT: "integrations.command_connect",
    COMMAND_CANCEL: "integrations.command_cancel",
    COMMAND_REMOVE: "integrations.command_remove",
    DEPLOY_SENSOR_CLICKED: "integrations.deploy_sensor.clicked",
    KODEMCI: {
      KODEM_CI: {
        OPENED_GENERATE_KEY: "integrations.kodemci.kodem_ci.generate_key",
        COMMAND_GENERATE_KEY:
          "integrations.kodemci.kodem_ci.command_generate_key"
      },
      JENKINS: {
        OPENED_GENERATE_KEY: "integrations.kodemci.jenkins.generate_key",
        COMMAND_GENERATE_KEY:
          "integrations.kodemci.jenkins.command_generate_key"
      },
      GITHUB_ACTIONS: {
        OPENED_GENERATE_KEY: "integrations.kodemci.github_actions.generate_key",
        COMMAND_GENERATE_KEY:
          "integrations.kodemci.github_actions.command_generate_key"
      },
      CIRCLE_CI: {
        OPENED_GENERATE_KEY: "integrations.kodemci.circle_ci.generate_key",
        COMMAND_GENERATE_KEY:
          "integrations.kodemci.circle_ci.command_generate_key"
      }
    },
    KODEMCLI: {
      OPENED_GENERATE_KEY: "integrations.kodemci.kodem_cli.generate_key",
      COMMAND_GENERATE_LINK:
        "integrations.kodemci.kodem_cli.command_generate_link",
      COMMAND_GENERATE_KEY:
        "integrations.kodemci.kodem_cli.command_generate_key",
      COMMAND_PLATFORM_SELECTED:
        "integrations.kodemci.kodem_cli.command_platform_selected"
    },
    GITHUB: {
      UPDATE_CONFIGURATION: "integrations.github.update_configuration"
    },
    BITBUCKET: {
      UPDATE_CONFIGURATION: "integrations.bitbucket.update_configuration"
    },
    PACKAGE_REGISTRY: {
      LIST_VIEWED: "package_registry_list_viewed",
      ADD_STARTED: "package_registry_add_started",
      TESTED: "package_registry_tested",
      SAVED: "package_registry_saved",
      CREDENTIAL_REPLACED: "package_registry_credential_replaced",
      FORMATS_EDITED: "package_registry_formats_edited",
      REMOVED: "package_registry_removed",
      MIGRATED_EDITED: "package_registry_migrated_edited"
    }
  },
  SBOM: {
    EXPORT: "sbom.export",
    SORT: "sbom.sort",
    COPYABLE: {
      CODE_REPOSITORY: "image_details_card.code_repo_copy",
      COMMAND: "image_details_card.command_copy",
      IMAGE_NAME: "image_details_card.image_name_copy"
    },
    DRAWER: {
      OPENED: "sbom.record",
      CLOSED: "sbom.drawer.closed",
      VULNERABILITIES: { CLICKED_CVE_LINK: "sbom.cve.cve_link" }
    }
  },
  REMEDIES: {
    SORT: "remedies.sort",
    DRAWER: { OPENED: "remedies.opened", CLOSED: "remedies.closed" },
    CREATE_ISSUE_JIRA: "remedies.jira.created"
  },
  TAB: {
    FILTER: {
      ADVANCE_SEARCH: {
        CLICK: {
          KEY: "key.click.advance_search.filter.tab",
          VALUE: "value.click.advance_search.filter.tab"
        }
      },
      QUICK_FILTERS: "quick_filters"
    }
  },
  INVENTORY: {
    DRAWERS: {
      ISSUES_EXPORT: "inventory.drawer.issues.export",
      SBOM_EXPORT: "inventory.drawer.sbom.export"
    },
    BASE_IMAGES: {
      EXPORT: "base_images.export",
      DRAWER: { OPENED: "inventory.base_images.drawer.opened" }
    },
    CODE_REPOSITORIES_TAB: {
      EXPORT: "code_repositories.export",
      DRAWER: {
        OPENED: "inventory.code_repositories.drawer.opened",
        CHANGE_TAB: "inventory.code_repositories.drawer.change_tab",
        TABS: {
          PACKAGES: {
            SORT: "inventory.code_repositories.drawer.tabs.packages.sort",
            EXPAND_ROW:
              "inventory.code_repositories.drawer.tabs.packages.expand_row"
          },
          ISSUES: {
            SORT: "inventory.code_repositories.drawer.tabs.issues.sort",
            EXPAND_ROW:
              "inventory.code_repositories.drawer.tabs.issues.expand_row"
          }
        }
      }
    },
    IMAGES: {
      EXPORT: "images.export",
      DRAWER: {
        OPENED: "inventory.images.drawer.opened",
        CHANGE_TAB: "inventory.images.drawer.change_tab",
        TABS: {
          PACKAGES: {
            SORT: "inventory.images.drawer.tabs.packages.sort",
            EXPAND_ROW: "inventory.images.drawer.tabs.packages.expand_row"
          },
          ISSUES: {
            SORT: "inventory.images.drawer.tabs.issues.sort",
            EXPAND_ROW: "inventory.images.drawer.tabs.issues.expand_row"
          }
        }
      }
    },
    APPLICATIONS: { EXPORT: "applications.export" },
    VIRTUAL_MACHINES: { EXPORT: "virtual_machines.export" }
  },
  QUICK_WINS: {
    BANNER: {
      CLICK: "quick_wins.banner.click"
    },
    PROJECT: {
      BOLT_BADGE_CLICK: "quick_wins.project.bolt_badge_click",
      HOVER_SHOW_ME: "quick_wins.project.hover_show_me",
      BANNER_SHOW_ME: "quick_wins.project.banner_show_me"
    },
    ISSUE: {
      BANNER_CLICK: "quick_wins.issue.banner_click"
    },
    DRAWER: {
      OPENED: "quick_wins.drawer.opened",
      CLOSED: "quick_wins.drawer.closed",
      TAB_CHANGE: "quick_wins.drawer.tab_change",
      FILTER_CHANGE: "quick_wins.drawer.filter_change",
      FILTER_CLEAR: "quick_wins.drawer.filter_clear"
    },
    CARD: {
      FIX: "quick_wins.card.fix",
      IGNORE: "quick_wins.card.ignore",
      RESTORE: "quick_wins.card.restore",
      VIEW_ISSUES: "quick_wins.card.view_issues",
      HIDE_ISSUES: "quick_wins.card.hide_issues",
      SHOW_MORE_ISSUES: "quick_wins.card.show_more_issues",
      ISSUE_CLICK: "quick_wins.card.issue_click"
    }
  },
  TRIAGE: {
    EXPAND_ROW: "triage.expand_row",
    CREATE_ISSUE_JIRA: "triage.jira.created",
    DISMISS_ISSUE: "triage.dismiss_issue",
    REOPEN_ISSUE: "triage.reopen_issue",
    EXPORT: "triage.export",
    CARD_FUNNEL_CLICK: "triage.card_funnel.click",
    SORT_TABLE: "triage.table.sort",
    DRAWER: {
      IN_RUNTIME_COLLAPSE_OPEN: "triage.drawer.in_runtime_collapse_open",
      COPY_HOW_TO_FIX: "triage.drawer.copy_how_to_fix",
      COPY_MANUAL_HOW_TO_FIX: "triage.drawer.copy_manual_how_to_fix",
      DROPDOWN_KAI_OCCURRENCES: "triage.drawer.dropdown_kai_occurrences",
      CLICK_GENERATE_FIX: "triage.drawer.click.generate-fix",
      TIME_EXECUTION_GENERATE_FIX: "triage.drawer.time-execution.generate-fix",
      CLICK_HYPERLINK_INTRODUCE_THROUGH:
        "triage.drawer.introduced-through.hyperlink.click",
      SAST_FIX: {
        GENERATION_SUCCESS: "triage.drawer.sast-fix.generation.success",
        GENERATION_ERROR: "triage.drawer.sast-fix.generation.error",
        GENERATION_CANCELLED: "triage.drawer.sast-fix.generation.cancelled",
        APPLY_FIX_CLICK: "triage.drawer.sast-fix.apply-fix.click",
        APPLY_FIX_SUCCESS: "triage.drawer.sast-fix.apply-fix.success",
        APPLY_FIX_ERROR: "triage.drawer.sast-fix.apply-fix.error",
        DOWNLOAD_PATCH: "triage.drawer.sast-fix.download-patch",
        MODAL_ABANDONED: "triage.drawer.sast-fix.modal.abandoned"
      }
    }
  },
  DRAWER: {
    OPENED: "drawer.opened",
    CLOSED: "drawer.closed",
    CHANGE_TAB: "drawer.change_tab",
    EXPAND_ROW: "drawer.expand_row",
    SORT: "drawer.sort",
    PAGINATION: "drawer.pagination"
  },
  SETTINGS: {
    USERS: {
      USER_INVITED: "user_invited",
      USER_UPDATED: "user_updated",
      USER_EXPORTED: "user_exported"
    },
    AUTH_KEYS: {
      API_KEYS: {
        COMMAND_GENERATE_KEY: "settings.api_key.command_generate_key"
      },
      DEPLOYMENT_KEYS: {
        COMMAND_GENERATE_KEY: "settings.deployment_key.command_generate_key"
      },
      SERVICE_KEYS: {
        COMMAND_GENERATE_KEY: "settings.service_key.command_generate_key"
      }
    }
  },
  ONBOARDING: {
    DISMISSED: "onboarding.dismissed",
    SPLASH_SCREEN: {
      GET_STARTED: "onboarding.get_started",
      DISPLAYED: "onboarding.displayed",
      SKIPPED: "onboarding.skipped"
    }
  },
  LABELS: {
    PATCH: "labels.patch",
    CREATE: "labels.create",
    UPDATE: "labels.update",
    DELETE: "labels.delete"
  },
  HELPFUL_FEEDBACK: { YES: "helpful_feedback.yes", NO: "helpful_feedback.no" },
  WORKFLOW: {
    CREATE: "workflows.create",
    EDIT: "workflows.edit",
    DELETE: "workflows.delete",
    REORDER: "workflows.reorder"
  },
  GUIDANCE: {
    SAVE: "kai_guidance_sast_saved",
    DELETE: "kai_guidance_sast_deleted",
    VALIDATION_ERROR_DISPLAYED: "kai_guidance_sast_error_displayed",
    REVISED_TEXT_ACCEPTED: "kai_guidance_sast_revised_text_accepted",
    REVISED_TEXT_REJECTED: "kai_guidance_sast_revised_text_rejected"
  },
  EVIDENCE: { DOWNLOAD: "evidence.download" },
  GOVERNANCE: {
    POLICIES: {
      ci: {
        CREATE: "ci_policy.create",
        EDIT: "ci_policy.edit",
        REORDER: "ci_policy.reorder",
        STATUS: "ci_policy.status",
        DELETE: "ci_policy.delete",
        CANCEL: "ci_policy.cancel"
      },
      "ci-sca": {
        CREATE: "ci_sca_policy.create",
        EDIT: "ci_sca_policy.edit",
        REORDER: "ci_sca_policy.reorder",
        STATUS: "ci_sca_policy.status",
        DELETE: "ci_sca_policy.delete",
        CANCEL: "ci_sca_policy.cancel"
      },
      "ci-sast": {
        CREATE: "ci_sast_policy.create",
        EDIT: "ci_sast_policy.edit",
        REORDER: "ci_sast_policy.reorder",
        STATUS: "ci_sast_policy.status",
        DELETE: "ci_sast_policy.delete",
        CANCEL: "ci_sast_policy.cancel"
      },
      scm: {
        CREATE: "scm_policy.create",
        EDIT: "scm_policy.edit",
        REORDER: "scm_policy.reorder",
        STATUS: "scm_policy.status",
        DELETE: "scm_policy.delete",
        CANCEL: "scm_policy.cancel"
      },
      code: {
        CREATE: "sast_policy.create",
        EDIT: "sast_policy.edit",
        REORDER: "sast_policy.reorder",
        STATUS: "sast_policy.status",
        DELETE: "sast_policy.delete",
        CANCEL: "sast_policy.cancel"
      }
    },
    SCAN_HISTORY: {
      EXPORT: "scan_history.export"
    }
  },
  KAI_CHAT: {
    SUBMIT_MESSAGE: "kai_chat.submit_message",
    CANCEL_CHAT: "kai_chat.cancel_chat",
    CREATE_NEW_CHAT: "kai_chat.create_new_chat",
    OPEN_CHAT: "kai_chat.open_chat",
    CLOSE_CHAT: "kai_chat.close_chat",
    CLICK_DRAWER_LINK: "kai_chat.click.drawer_link"
  },
  REPORTS: {
    CLICK_GENERATE_REPORT: "reports.click.generate",
    CREATE_REPORT: "reports.create_report",
    UPDATE_REPORT: "reports.update_report",
    DOWNLOAD_REPORT: "reports.download",
    EDIT_REPORT: "reports.edit"
  },
  ADR: {
    OPEN_DISMISSED_TAB: "adr.open_dismissed_tab",
    SWITCH_DETAILS_SECTION: "adr.switch_details_section",
    NAVIGATE_INCIDENT_PAGE: "adr.navigate_incident_page",
    SWITCH_TABS_ADR_PAGE: "adr.switch_tabs_incident_page",
    DISMISS_INCIDENT: "adr.dismiss_incident_incident_page"
  },
  HIGH_PROFILE_VULNERABILITIES: {
    OPENED: "high_profile_events.opened",
    CLICKED: "high_profile_events.clicked",
    EXTERNAL_LINK_CLICKED: "high_profile_events.external_link_clicked"
  },
  POLICY_EXCEPTION: {
    SUBMIT_REQUEST: "policy_exception.request.submit",
    START_EDIT: "policy_exception.request.edit_start",
    SAVE_EDIT: "policy_exception.request.edit_save",
    CANCEL_EDIT: "policy_exception.request.edit_cancel",
    SUBMIT_DECISION: "policy_exception.decision.submit",
    OPEN_PULL_REQUEST: "policy_exception.pull_request.opened"
  }
}

export const ERROR_EVENTS = {
  APPLICATION: { CHECK_VERSION: "ERROR_CHECK_VERSION" },
  NETWORK: {
    ERROR: "ERROR_NETWORK",
    ERROR_RECEIVING_DATA_FROM_NETWORK: "ERROR_RECEIVING_DATA_FROM_NETWORK"
  },
  SIGN_IN: "ERROR_SIGN_IN_FUNCTION",
  SIGNIN_POPUP: "ERROR_SIGNIN_POPUP_FUNCTION",
  SIGN_OUT: "ERROR_SIGN_OUT_FUNCTION",
  INTEGRATIONS: {
    INVALID_PARAMS: "INVALID_PARAMS",
    ERROR: "ERROR_INTEGRATIONS",
    REQUESTED: "REQUESTED_INTEGRATIONS",
    SUCCESS: "SUCCESS_INTEGRATIONS"
  },
  SCOPES: {
    ERROR_CREATE_SCOPE: "ERROR_CREATE_SCOPE",
    ERROR_UPDATE_SCOPE: "ERROR_UPDATE_SCOPE",
    ERROR_DELETE_SCOPE: "ERROR_DELETE_SCOPE"
  },
  AUTH: {
    MISSING_PARAM_IN_LINK: "ERROR_MISSING_PARAM",
    ACCEPT_INVITE: "ERROR_ACCEPT_INVITE",
    VERIFY_CODE_OOB: "ERROR_VERIFY_CODE_OOB"
  },
  ERROR_BOUNDARY: {
    LAYOUT: "ERROR_BOUNDARY_LAYOUT",
    DRAWER: "ERROR_BOUNDARY_DRAWER",
    SIGNIN_POPUP: "ERROR_BOUNDARY_SIGNIN_POPUP"
  },
  ACTIONS: { DELETE_ENTITY_CONFIRM_MODAL: "DELETE_ENTITY_CONFIRM_MODAL" },
  REPORTS: {
    ISSUE_REPORT: "reports.issue_report"
  },
  KAI_CHAT: {
    ERROR: "kai_chat.error"
  },
  JIRA: {
    LINK_JIRA_TO_ISSUE_FAILURE: "LINK_JIRA_TO_ISSUE_FAILURE",
    UNLINK_JIRA_TO_ISSUE_FAILURE: "UNLINK_JIRA_TO_ISSUE_FAILURE"
  }
}

export const INTERNAL_EVENTS = {
  CLEAR_FILTERS_TABLE_TAB_TEMPLATE: "__clear_filters_table_tab_template__"
}

export const EVENTS = { ANALYTIC_EVENTS, ERROR_EVENTS }
